import Vue from 'vue';
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import VueCropper from 'vue-cropperjs';
import Select2 from './vendor/select2';
import AOS from 'aos'
import {Form} from './forms/form';
import helpers from './helpers';
import BackgroundTasks from './components/BackgroundTasks';
import FirmwareImageVersions from './components/FirmwareImageVersions';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.use({
    install() {
        Vue.helpers = helpers;
        Vue.prototype.$helpers = helpers;
    }
});

// Machine module
import MachineForm from '../../../../Modules/Machine/Resources/assets/js/components/MachineForm.vue';
import MachinePackages from '../../../../Modules/Machine/Resources/assets/js/components/MachinePackages.vue';
import MachineMenuForm from '../../../../Modules/Machine/Resources/assets/js/components/MachineMenuForm.vue';
import MachineDetails from '../../../../Modules/Machine/Resources/assets/js/components/MachineDetails.vue';
import MachineTypeForm from '../../../../Modules/Machine/Resources/assets/js/components/MachineTypeForm.vue';
import MachineTemplateForm from '../../../../Modules/Machine/Resources/assets/js/components/MachineTemplateForm.vue';
import MachineTemplatePackages from '../../../../Modules/Machine/Resources/assets/js/components/MachineTemplatePackages.vue';
import MachineTemplateMenuForm from '../../../../Modules/Machine/Resources/assets/js/components/MachineTemplateMenuForm.vue';
import MachineGroupForm from '../../../../Modules/Machine/Resources/assets/js/components/MachineGroupForm.vue';

// User module
import UserForm from '../../../../Modules/User/Resources/assets/js/components/UserForm.vue';
import UserGroupForm from '../../../../Modules/User/Resources/assets/js/components/UserGroupForm.vue';
import RoleForm from '../../../../Modules/User/Resources/assets/js/components/RoleForm.vue';
import BindForm from '../../../../Modules/User/Resources/assets/js/components/BindForm.vue';
import AccountForm from '../../../../Modules/User/Resources/assets/js/components/AccountForm.vue';

// FileManager module
import FileManager from '../../../../Modules/FileManager/Resources/assets/js/components/FileManager.vue';
import FileManagerModal from '../../../../Modules/FileManager/Resources/assets/js/components/FileManagerModal.vue';
import FileManagerImageSelect from '../../../../Modules/FileManager/Resources/assets/js/components/FileManagerImageSelect.vue';
import FileManagerImagesSelect from '../../../../Modules/FileManager/Resources/assets/js/components/FileManagerImagesSelect.vue';
import FileManagerFileSelect from '../../../../Modules/FileManager/Resources/assets/js/components/FileManagerFileSelect.vue';
import FileManagerFilesSelect from '../../../../Modules/FileManager/Resources/assets/js/components/FileManagerFilesSelect.vue';
import FileManagerPathSelect from '../../../../Modules/FileManager/Resources/assets/js/components/FileManagerPathSelect.vue';
import FileManagerBrowse from '../../../../Modules/FileManager/Resources/assets/js/components/FileManagerBrowse.vue';

// Game module
import GameLibrary from '../../../../Modules/Game/Resources/assets/js/components/game-library/GameLibrary';
import GameLibraryArea from '../../../../Modules/Game/Resources/assets/js/components/game-library/GameLibraryArea';
import GameLibraryAreaModal from '../../../../Modules/Game/Resources/assets/js/components/game-library/GameLibraryAreaModal';
import GameLibrarySet from '../../../../Modules/Game/Resources/assets/js/components/game-library/GameLibrarySet';
import GameLibrarySetModal from '../../../../Modules/Game/Resources/assets/js/components/game-library/GameLibrarySetModal';
import GameLibraryPackage from '../../../../Modules/Game/Resources/assets/js/components/game-library/GameLibraryPackage';
import GameLibraryPackageModal from '../../../../Modules/Game/Resources/assets/js/components/game-library/GameLibraryPackageModal';
import GameLibraryGame from '../../../../Modules/Game/Resources/assets/js/components/game-library/GameLibraryGame';
import GameLibraryGameModal from '../../../../Modules/Game/Resources/assets/js/components/game-library/GameLibraryGameModal';
import GameLibraryAssignGamesModal from '../../../../Modules/Game/Resources/assets/js/components/game-library/GameLibraryAssignGamesModal';
import GameLibraryElementChangelogModal from '../../../../Modules/Game/Resources/assets/js/components/game-library/GameLibraryElementChangelogModal';
import GameLibraryMoveModal from '../../../../Modules/Game/Resources/assets/js/components/game-library/GameLibraryMoveModal';
import GameLibraryManageTagsModal from '../../../../Modules/Game/Resources/assets/js/components/game-library/GameLibraryManageTagsModal';
import GameLibraryApproveGameModal from '../../../../Modules/Game/Resources/assets/js/components/game-library/GameLibraryApproveGameModal';
import GameLibraryApproveGameTranslationsModal from '../../../../Modules/Game/Resources/assets/js/components/game-library/GameLibraryApproveGameTranslationsModal';
import GameLibraryApproveMenuModal from '../../../../Modules/Game/Resources/assets/js/components/game-library/GameLibraryApproveMenuModal';
import GameLibraryApproveMenuTranslationsModal from '../../../../Modules/Game/Resources/assets/js/components/game-library/GameLibraryApproveMenuTranslationsModal';
import QuizEditFileComponent from '../../../../Modules/Game/Resources/assets/js/components/editors/quiz/QuizEditFileComponent';
import QuizImportCsvComponent from '../../../../Modules/Game/Resources/assets/js/components/editors/quiz/QuizImportCsvComponent';
import MarketingResources from '../../../../Modules/Game/Resources/assets/js/components/marketing-resources/MarketingResources';
import MarketingResourcesArea from '../../../../Modules/Game/Resources/assets/js/components/marketing-resources/MarketingResourcesArea';
import MarketingResourcesPackage from '../../../../Modules/Game/Resources/assets/js/components/marketing-resources/MarketingResourcesPackage';
import MarketingResourcesSet from '../../../../Modules/Game/Resources/assets/js/components/marketing-resources/MarketingResourcesSet';
import MarketingResourcesGame from '../../../../Modules/Game/Resources/assets/js/components/marketing-resources/MarketingResourcesGame';
import MarketingResourcesElementEditModal from '../../../../Modules/Game/Resources/assets/js/components/marketing-resources/MarketingResourcesElementEditModal';
import MarketingResourcesElementTranslateModal from '../../../../Modules/Game/Resources/assets/js/components/marketing-resources/MarketingResourcesElementTranslateModal';
import MarketingResourcesElementPreviewModal from '../../../../Modules/Game/Resources/assets/js/components/marketing-resources/MarketingResourcesElementPreviewModal';
import MarketingResourcesSectionsModal from '../../../../Modules/Game/Resources/assets/js/components/marketing-resources/MarketingResourcesSectionsModal';
import MarketingResourcesSectionsTranslateModal from '../../../../Modules/Game/Resources/assets/js/components/marketing-resources/MarketingResourcesSectionsTranslateModal';

// Customer module
import PackageContent from '../../../../Modules/Customer/Resources/assets/js/components/PackageContent';
import PackageContentSetModal from '../../../../Modules/Customer/Resources/assets/js/components/PackageContentSetModal';
import PackageContentGameModal from '../../../../Modules/Customer/Resources/assets/js/components/PackageContentGameModal';
import GameContentEditFile from '../../../../Modules/Customer/Resources/assets/js/components/GameContentEditFile';
import GameContentImportCsv from '../../../../Modules/Customer/Resources/assets/js/components/GameContentImportCsv';

// Pendrive module
import PendriveTemplateForm from '../../../../Modules/Pendrive/Resources/assets/js/components/PendriveTemplateForm';
import PendriveTemplatePackages from '../../../../Modules/Pendrive/Resources/assets/js/components/PendriveTemplatePackages';
import PendriveTemplateMenuForm from '../../../../Modules/Pendrive/Resources/assets/js/components/PendriveTemplateMenuForm.vue';

// ActiveCues module
import ActiveCuesSoftware from '../../../../Modules/ActiveCues/Resources/assets/js/components/ActiveCuesSoftware';

window.Vue = Vue;
window.axios = require('axios');

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.headers.common["X-CSRF-TOKEN"] = window.CONFIG.CSRF_TOKEN;

axios.interceptors.response.use(function(response){
    return response;
}, function(error){
    if (error.response.status === 401 || error.response.status === 419) {
        window.location.reload();
    }
    return Promise.reject(error);
});

Vue.config.performance = true;

Vue.prototype.CONFIG = window.CONFIG;
Vue.prototype.userHasPermission = window.userHasPermission;
Vue.prototype.userHasOneOfPermissions = window.userHasOneOfPermissions;
Vue.prototype.t = window.t;
Vue.prototype.Form = Form;

// Vendor
Vue.component('vue-cropper', VueCropper);
Vue.component('select2', Select2);

// Main
Vue.component('background-tasks', BackgroundTasks);
Vue.component('firmware-image-versions', FirmwareImageVersions);

// Machine module
Vue.component('machine-form', MachineForm);
Vue.component('machine-packages', MachinePackages);
Vue.component('machine-menu-form', MachineMenuForm);
Vue.component('machine-details', MachineDetails);
Vue.component('machine-type-form', MachineTypeForm);
Vue.component('machine-template-form', MachineTemplateForm);
Vue.component('machine-template-packages', MachineTemplatePackages);
Vue.component('machine-template-menu-form', MachineTemplateMenuForm);
Vue.component('machine-group-form', MachineGroupForm);

// User module
Vue.component('user-form', UserForm);
Vue.component('user-group-form', UserGroupForm);
Vue.component('role-form', RoleForm);
Vue.component('bind-form', BindForm);
Vue.component('account-form', AccountForm);

// FileManager module
Vue.component('file-manager', FileManager);
Vue.component('file-manager-modal', FileManagerModal);
Vue.component('file-manager-image-select', FileManagerImageSelect);
Vue.component('file-manager-images-select', FileManagerImagesSelect);
Vue.component('file-manager-file-select', FileManagerFileSelect);
Vue.component('file-manager-files-select', FileManagerFilesSelect);
Vue.component('file-manager-path-select', FileManagerPathSelect);
Vue.component('file-manager-browse', FileManagerBrowse);

// Game module
Vue.component('game-library', GameLibrary);
Vue.component('game-library-area', GameLibraryArea);
Vue.component('game-library-area-modal', GameLibraryAreaModal);
Vue.component('game-library-set', GameLibrarySet);
Vue.component('game-library-set-modal', GameLibrarySetModal);
Vue.component('game-library-package', GameLibraryPackage);
Vue.component('game-library-package-modal', GameLibraryPackageModal);
Vue.component('game-library-game', GameLibraryGame);
Vue.component('game-library-game-modal', GameLibraryGameModal);
Vue.component('game-library-assign-games-modal', GameLibraryAssignGamesModal);
Vue.component('game-library-move-modal', GameLibraryMoveModal);
Vue.component('game-library-element-changelog-modal', GameLibraryElementChangelogModal);
Vue.component('game-library-manage-tags-modal', GameLibraryManageTagsModal);
Vue.component('game-library-approve-game-modal', GameLibraryApproveGameModal);
Vue.component('game-library-approve-game-translations-modal', GameLibraryApproveGameTranslationsModal);
Vue.component('game-library-approve-menu-modal', GameLibraryApproveMenuModal);
Vue.component('game-library-approve-menu-translations-modal', GameLibraryApproveMenuTranslationsModal);
Vue.component('quiz-edit-file', QuizEditFileComponent);
Vue.component('quiz-import-csv', QuizImportCsvComponent);
Vue.component('marketing-resources', MarketingResources);
Vue.component('marketing-resources-area', MarketingResourcesArea);
Vue.component('marketing-resources-package', MarketingResourcesPackage);
Vue.component('marketing-resources-set', MarketingResourcesSet);
Vue.component('marketing-resources-game', MarketingResourcesGame);
Vue.component('marketing-resources-element-edit-modal', MarketingResourcesElementEditModal);
Vue.component('marketing-resources-element-translate-modal', MarketingResourcesElementTranslateModal);
Vue.component('marketing-resources-element-preview-modal', MarketingResourcesElementPreviewModal);
Vue.component('marketing-resources-sections-modal', MarketingResourcesSectionsModal);
Vue.component('marketing-resources-sections-translate-modal', MarketingResourcesSectionsTranslateModal);

// Customer module
Vue.component('package-content', PackageContent);
Vue.component('package-content-set-modal', PackageContentSetModal);
Vue.component('package-content-game-modal', PackageContentGameModal);
Vue.component('game-content-edit-file', GameContentEditFile);
Vue.component('game-content-import-csv', GameContentImportCsv);

// Pendrive module
Vue.component('pendrive-template-form', PendriveTemplateForm);
Vue.component('pendrive-template-packages', PendriveTemplatePackages);
Vue.component('pendrive-template-menu-form', PendriveTemplateMenuForm);

// ActiveCues module
Vue.component('active-cues-software', ActiveCuesSoftware);

// Event handler
if (!window.eventHub) {
    window.eventHub = new Vue();
}

Vue.mixin({
    methods: {
        route: route
    }
});

new Vue({
    el: '#app',
    components: {

    },
    data: {
        eventHub: window.eventHub,
        fileManager: {
            show: false,
            modal: false,
            eventName: null,
            mimeTypes: null,
            basePath: null,
            disableWriteAccess: false
        }
    },
    methods: {
        formSubmit(stay = 0) {
            this.$nextTick(() => {
                $('#overlay').fadeIn();
                $('.loader').fadeIn();
                this.eventHub.$emit('submit-form', stay);
            });
        },
        emitEvent(event, showOverlay = true) {
            this.$nextTick(() => {
                if (showOverlay) {
                    $('#overlay').fadeIn();
                    $('.loader').fadeIn();
                }
                this.eventHub.$emit(event);
            });
        }

    },
    created () {
        AOS.init({
            once: true
        })
    },
    mounted() {

        this.eventHub.$on('processing-start', () => {
            $('#overlay').fadeIn();
            $('.loader').fadeIn();
        });

        this.eventHub.$on('processing-finish', () => {
            $('.loader').fadeOut();
            $('#overlay').fadeOut();
        });

        this.eventHub.$on('toast-notification', showNotification);

        this.eventHub.$on('show-file-manager', (uid, selectType, mimeTypes, basePath = null, disableWriteAccess = false) => {
            this.fileManager.eventName = uid;
            this.fileManager.mimeTypes = mimeTypes;
            this.fileManager.modal = selectType;
            this.fileManager.basePath = basePath;
            this.fileManager.disableWriteAccess = disableWriteAccess;
            this.fileManager.show = true;
        });

        this.eventHub.$on('hide-file-manager', () => {
            this.fileManager.show = false;
            this.fileManager.modal = false;
            this.fileManager.basePath = null;
            this.fileManager.disableWriteAccess = false;
            this.fileManager.eventName = null;
        });
    }
});
